import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as fromLayout from '..';
import * as fromAuth from '../../auth';
import { NEW_CHAT_TITLE_DEFAULT } from '../../chats/chats.constants';
import { ChatsHelper } from '../../chats/chats.helper';
import { chatsFeature, ChatsState } from '../../chats/store/chats.reducer';
import { SidebarDesktopResponsive } from './sidebar.desktop.responsive';
import { SidebarMobileResponsive } from './sidebar.mobile.responsive';

@Component({
  selector: 'dmcom-sidebar',
  imports: [SidebarDesktopResponsive, SidebarMobileResponsive],
  template: `
    @let user = currentUser();
    @if (user) {
      @if (isMobile()) {
        <dmcom-sidebar-mobile
          [userInitials]="user.initials"
          [userName]="user.displayName"
        />
      } @else {
        <dmcom-sidebar-desktop
          [userInitials]="user.initials"
          [userName]="user.displayName"
          [itemNavigations]="itemsNavigations()"
        />
      }
    }
  `,
  providers: [ChatsHelper],
})
export class SidebarComponent {
  private readonly layoutStore = inject(Store<fromLayout.LayoutState>);
  private readonly authStore = inject(Store<fromAuth.AuthState>);
  private readonly chatsStore = inject<Store<ChatsState>>(Store);
  private readonly chatsHelper = inject(ChatsHelper);

  public readonly currentUser = toSignal(
    this.authStore.select(fromAuth.authFeature.selectUser),
  );
  public readonly isMobile = toSignal(
    this.layoutStore.select(fromLayout.layoutFeature.selectIsMobile),
  );

  public readonly itemsNavigations = computed(() => {
    const items = this.chatsStore.selectSignal(
      chatsFeature.selectChatsAsItemNavigation,
      {},
    );

    return items().map((item) => {
      if (!item.title || item.title === NEW_CHAT_TITLE_DEFAULT) {
        return {
          ...item,
          title: this.chatsHelper.getChatTitle(item.title),
        };
      }
      return item;
    });
  });
}
